import { getSearchParams } from 'gatsby-query-params';

export default function getLanguage() {
  const keys = Object.keys(getSearchParams());
  return keys.includes('th') ? 'th' : 'en';
}
